export class ControllerClimateLogicSettings
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    TimeFormat: number;
    ConType: number;
    ScheduleUpdateTime: number;
    ZipOrLatLong: number;
    ZipCode: string;
    MaxPercentAdjAllowed: number;
    MinPercentAdjAllowed: number;
    GrowInDelayDays: number;
    EtSensorId: number;
}
